import axios from 'axios'

const service = axios.create({
  baseURL: '/api',
  timeout: 10000
})

service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    console.error('Response error:', error)
    return Promise.reject(error)
  }
)

export default {
  getDevices(params) {
    return service.get('/devices', { params })
  },
  addDevice(data) {
    return service.post('/devices', data)
  },
  updateDevice(id, data) {
    return service.put(`/devices/${id}`, data)
  },
  deleteDevice(id) {
    return service.delete(`/devices/${id}`)
  },
  getDeviceById(id) {
    return service.get(`/devices/${id}`)
  },
  getDeviceData(params) {
    return service.get('/devices/data', { params })
  },
  getAlarms(params) {
    return service.get('/alarms', { params })
  },
  handleAlarm(id, data) {
    return service.put(`/alarms/${id}`, data)
  },
  getRules(params) {
    return service.get('/rules', { params })
  },
  addRule(data) {
    return service.post('/rules', data)
  },
  updateRule(id, data) {
    return service.put(`/rules/${id}`, data)
  },
  deleteRule(id) {
    return service.delete(`/rules/${id}`)
  },
  getStatistics() {
    return service.get('/statistics')
  },
  getReportData(params) {
    return service.get('/reports', { params })
  },
  getDeviceTypes() {
    return service.get('/device-types')
  },
  getDeviceTemplates(params) {
    return service.get('/device-templates', { params })
  },
  addDeviceTemplate(data) {
    return service.post('/device-templates', data)
  },
  updateDeviceTemplate(id, data) {
    return service.put(`/device-templates/${id}`, data)
  },
  deleteDeviceTemplate(id) {
    return service.delete(`/device-templates/${id}`)
  },
  sendCommandToDevice(id, command) {
    return service.post(`/devices/${id}/command`, command)
  },
  resetDevicePassword(id) {
    return service.post(`/devices/${id}/reset-password`)
  },
  updateDeviceVariable(id, variableId, value) {
    return service.put(`/devices/${id}/variables/${variableId}`, { value })
  },
  getVariableHistory(deviceId, variableId, params) {
    return service.get(`/history/device/${deviceId}/variable/${variableId}`, { params })
  },
  getVariableHistoryChart(deviceId, variableId, params) {
    return service.get(`/history/device/${deviceId}/variable/${variableId}/chart`, { params })
  },
  getVariableRecentHistory(deviceId, variableId, hours = 24) {
    return service.get(`/history/device/${deviceId}/variable/${variableId}/recent`, { params: { hours } })
  },
  getDeviceVariables(deviceId) {
    return service.get(`/devices/${deviceId}/variables`)
  },
  getAllDeviceVariables() {
    return service.get('/devices/variables')
  },
  getDeviceTypeDistribution() {
    return service.get('/statistics/device-type-distribution')
  },
  getAlarmTypeDistribution() {
    return service.get('/statistics/alarm-type-distribution')
  },
  getTrendData(params) {
    return service.get('/statistics/trend', { params })
  },

  // 查询设备成员列表（含 owner/member 角色）
  getDeviceMembers(deviceId) {
    return service.get(`/devices/${deviceId}/members`)
  },

  // 管理员移除设备成员（释放绑定名额）
  removeDeviceMember(deviceId, userId) {
    return service.delete(`/devices/${deviceId}/members/${userId}`)
  },

  // ===== OTA 固件升级 =====
  // 获取固件列表
  getFirmwares() {
    return service.get('/firmwares')
  },
  // 上传固件包（FormData：file、version、deviceType、remark），超时单独放宽到 60s
  uploadFirmware(formData) {
    return service.post('/firmwares/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000
    })
  },
  // 删除固件
  deleteFirmware(id) {
    return service.delete(`/firmwares/${id}`)
  },
  // 一键下发升级：把指定固件下发到指定设备
  deployFirmware(firmwareId, deviceId) {
    return service.post(`/firmwares/${firmwareId}/deploy`, { deviceId })
  },
  // 批量下发升级：把指定固件下发到多台设备，逐台处理并返回每台结果
  deployFirmwareBatch(firmwareId, deviceIds) {
    return service.post(`/firmwares/${firmwareId}/deploy-batch`, { deviceIds })
  },
  // 查询设备升级记录
  getOtaRecords(deviceId) {
    return service.get(`/firmwares/records/${deviceId}`)
  },
  // 取消待处理的升级任务（仅 pending 状态可取消）
  cancelOta(recordId) {
    return service.post(`/firmwares/records/${recordId}/cancel`)
  }
}
